// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-heading{margin:32px 0;display:flex;flex-direction:column;align-items:center}.c-heading__title,.c-heading__subtitle{color:var(--text);text-align:center}.c-heading__title{font-size:20px;font-weight:700;line-height:149.17%}.c-heading__subtitle{font-size:16px;font-weight:400;line-height:118%;margin-top:8px}\n", ""]);
// Exports
module.exports = exports;
